module.exports = __webpack_public_path__ + "img/training_1.47c42f7d.png";